import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const RUFlagIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M0.5 0.5H15.5V11.5H0.5V0.5Z"
          fill="url(#paint0_linear_11540_191997)"
          stroke="#D9E6F7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4H16V8H0V4Z"
          fill="url(#paint1_linear_11540_191997)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8H16V12H0V8Z"
          fill="url(#paint2_linear_11540_191997)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11540_191997"
            x1="168"
            y1="0"
            x2="168"
            y2="180"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#F0F0F0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_11540_191997"
            x1="168"
            y1="4"
            x2="168"
            y2="64"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0C47B7" />
            <stop offset="1" stopColor="#073DA4" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_11540_191997"
            x1="168"
            y1="8"
            x2="168"
            y2="68"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E53B35" />
            <stop offset="1" stopColor="#D32E28" />
          </linearGradient>
        </defs>
      </svg>
    );
  },
);
